const prefix = "INVOICE_";

export const DUE_GET = prefix + "DUE_GET";
export const DUE_SAVE = prefix + "DUE_SAVE";
export const EXPORT = prefix + "EXPORT";
export const GET_TRANSACTIONS = prefix + "GET_TRANSACTIONS";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const RECONCILE = prefix + "RECONCILE";
export const RECONCILE_TESTING_TOOL = prefix + "RECONCILE_TESTING_TOOL";
export const VIEW = prefix + "VIEW";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
